import React from 'react';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './ColumnOrderSuccessModal.module.scss';

export const ColumnOrderSuccessModal = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <SalonModal tag="ColumnOrderSuccessModal" isOpen variant="noFooter">
      <SalonModal.Header>
        <div className={CN.closeButtonContainer}>
          <Button variant="empty" onClick={onClick}>
            <Icon variant="close" variantInvert />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <div className={CN.image}>
          <IconStatus variant="alert">
            <Icon variant="alert" />
          </IconStatus>
        </div>
        <div className={CN.content}>
          <div className={CN.title}>{t('scheduler.dayScheduler.refreshSuccessModal.title')}</div>
          <span className={CN.text}>{t('scheduler.dayScheduler.refreshSuccessModal.description')}</span>
        </div>
      </SalonModal.Body>
    </SalonModal>
  );
};
